import { toast as SonnerToast } from "sonner";
import { Alert, AlertType } from "@/components/ui/alert";

/* Prop Types */
interface ToastProps {
  title?: string;
  description?: string;
  type?: AlertType;
  className?: string;
}

/*
 * Toast function
 * This function is used to display a toast message and invoke toaster component
 */
export const toast = ({ title, description, type = "default", className }: ToastProps) => {
  /* Render */
  SonnerToast.custom(() => <Alert title={title} description={description} type={type} className={className} />);
};
